import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {settingsDeleteCustomFieldsAction} from '../../../store/panels/settings/settingsPanelActions';
import {EditCustomFieldForm} from './editCustomFieldForm';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onDeleteCustomFields: settingsDeleteCustomFieldsAction,
}));

export const EditCustomFieldFormContainer = connect(null, mapDispatchToProps)(EditCustomFieldForm);
